import { Chip } from '@mui/material'

export default function StatusChip({ status }) {
  let color;
  switch (('' + status).toLowerCase()) {
    case 'active':
      color = 'success';
      break;
    case 'inactive':
      color = 'default';
      break;
    case 'draft':
      color = 'warning';
      break;
    case 'approved':
      color = 'success';
      break;
    case 'rejected':
      color = 'error';
      break;
    default:
      color = 'default';
  }

  return <Chip label={status} color={color} size="small"/>;
}